<template>
  <DepartmentHero
    :breadcrumbs="data.breadcrumbs || []"
    :title="data.title || ''"
    :description="data.description || ''"
    :secondary-button="data.secondaryButton || {}"
    :review-button="data.reviewButton || {}"
    :image="data.image || ''"
    :image-alt="data.imageAlt || ''"
    :about-heading="data.aboutHeading || ''"
    :about-text="data.aboutText || ''"
    :gallery="data.gallery || []"
    :stats="data.stats || []"
  />
</template>

<script>
import DepartmentHero from '@/components/Departments/DepartmentHero.vue'

export default {
  name: 'AppDepartmentHeroBlock',
  components: { DepartmentHero },
  props: {
    data: { type: Object, default: () => ({}) },
  },
}
</script>
